import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const appRoutes: Route[] = [
	{
		path: '',
		canMatch: [MsalGuard],
		loadChildren: () => import('./my/my.module').then((m) => m.MyModule),
	},
	{
		path: '',
		loadChildren: () => import('./landing/landing.module').then((m) => m.LandingModule),
	},
];
